module.exports = __webpack_public_path__ + "static/media/50.64c6834f.png";